import React from 'react';
import { AlertTriangle, AlertCircle, Info } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

const IncidentBanner = ({ incidents }) => {
  if (!incidents || incidents.length === 0) {
    return null;
  }

  const getSeverityConfig = (severity) => {
    switch (severity) {
      case 'critical':
        return {
          bgColor: 'bg-red-500/10',
          borderColor: 'border-red-500/30',
          textColor: 'text-red-400',
          icon: AlertTriangle,
          badgeBg: 'bg-red-500/20',
          badgeText: 'text-red-300',
        };
      case 'high':
        return {
          bgColor: 'bg-orange-500/10',
          borderColor: 'border-orange-500/30',
          textColor: 'text-orange-400',
          icon: AlertCircle,
          badgeBg: 'bg-orange-500/20',
          badgeText: 'text-orange-300',
        };
      case 'medium':
        return {
          bgColor: 'bg-yellow-500/10',
          borderColor: 'border-yellow-500/30',
          textColor: 'text-yellow-400',
          icon: Info,
          badgeBg: 'bg-yellow-500/20',
          badgeText: 'text-yellow-300',
        };
      default:
        return {
          bgColor: 'bg-gray-500/10',
          borderColor: 'border-gray-500/30',
          textColor: 'text-gray-400',
          icon: Info,
          badgeBg: 'bg-gray-500/20',
          badgeText: 'text-gray-300',
        };
    }
  };

  return (
    <div className="space-y-3">
      {incidents.map((incident) => {
        const config = getSeverityConfig(incident.severity);
        const Icon = config.icon;
        const timeAgo = formatDistanceToNow(new Date(incident.started_at), {
          addSuffix: true,
        });

        return (
          <div
            key={incident.id}
            className={`p-4 rounded-lg border ${config.bgColor} ${config.borderColor}`}
          >
            <div className="flex items-start gap-4">
              <Icon className={`w-5 h-5 ${config.textColor} flex-shrink-0 mt-0.5`} />
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h4 className="text-lg font-semibold text-white">
                    {incident.endpoint?.label || 'Unknown Endpoint'}
                  </h4>
                  <span
                    className={`px-2 py-0.5 rounded text-xs font-semibold uppercase ${config.badgeBg} ${config.badgeText}`}
                  >
                    {incident.severity}
                  </span>
                </div>
                <p className="text-sm text-gray-300 mb-2">
                  {incident.description}
                </p>
                <div className="flex items-center gap-4 text-xs text-gray-400">
                  <span>Started {timeAgo}</span>
                  {incident.service && (
                    <span>Service: {incident.service.name}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default IncidentBanner;
